// extracted by css-extract-rspack-plugin
export default {"date":"Show__date--AHG5B","title":"Show__title--dBWWb","body":"Show__body--ZNGee"};